// 定义 Store
export const useUserInfoStore = defineStore(
  'userInfo',
  () => {
    const userDetail: any = ref({});
    const setUserDetail = async (val: any) => {
      userDetail.value = val;
    };

    return {
      userDetail,
      setUserDetail,
    };
  },
  {
    persist: true,
  }
);
